function initCartMemoSync() {
  // changeイベントを重複登録しないよう、まずoffしてからon
  $(document)
    .off("change.cartmemo")
    .on("change.cartmemo", "#Cart-note", function() {
      $("#CartDrawer-Note").val($(this).val());
    })
    .on("change.cartmemo", "#CartDrawer-Note", function() {
      $("#Cart-note").val($(this).val());
    });
}

$(document).ready(function() {
  initCartMemoSync();

  // Refreshテーマ対応：ドロアー開いた時に再接続
  document.addEventListener('cart-drawer:opened', () => {
    setTimeout(initCartMemoSync, 100);
  });
});